import { useGetEventUnits, useGetNocs } from 'helpers/commonCodes';
import { useGetURL, useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useGetFunctionOCSUrl, usePathFlag } from 'helpers/utils';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useViewport } from 'components/general/useViewPort';


export const Noc = (props) => {
    const [showImage, setShowImage] = useState(false);
    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "sm" || breakPoint === "xs");
    // hide NOC code until md size  
    const [classNameForNoc, setClassNameForNoc] = useState("me-1");
    const params = useUrlFriendlyToParameters()
    const nocList = useGetNocs(params)

    const dataUnits = useGetEventUnits(params);
    const getURL = useGetURL();
    const getOCSURL = useGetFunctionOCSUrl()

    const eventUnit = dataUnits?.eventUnits && dataUnits?.eventUnits?.find(item => item.code === params.mirs_rsc)

    let noc = props.code || props?.organisationId;
    let nocDesc = (props.longDescription) ? props.longDescription : props.description;

    if (!nocDesc) {
        const nocObject = nocList?.nocs?.find(n => n?.code === noc);
        nocDesc = (props?.longDescription) ? nocObject?.longDescription : nocObject?.description;
    }

    const pathFlag = usePathFlag(noc)
    const clientClass = `noc-${noc}`;
    const hasLink = props.hasLink;
    const urlLink = props.urlLink;
    const showImgAlt = props.showImgAlt !== undefined ? props.showImgAlt : true;

    let codeUrl = urlLink ? urlLink : 'schedulebynoc'
    let paramURL = { ...params }
    paramURL.mirs_noc = noc
    let url = getURL(paramURL, codeUrl)
    url = getOCSURL(url, codeUrl, paramURL)

    /*
    The following commented code was a part of a fix of defect '861051- HT:TRI:ODS:WRS/MyInfo:Race Facts: NOC Flag lost during the competition'
    Te git commit ID is: e4032cf801bdac305e964caed504dffec44b2faa
    The reason of commenting this code is because it has a side effect in Ribbon component.
    The side efect is that the flags are not shown (sometimes) when you navigate across the units
    */

    /*
    useLayoutEffect(() => {
        setShowImage(false); 
    }, [noc]);
    */

    useEffect(() => {
        if (!showImage) {
            checkImageExists(pathFlag, (exists) => {
                if (exists) {
                    setShowImage(true);
                    setClassNameForNoc(props?.hideNocCode ? "me-1 d-none d-md-block" : "me-1");
                }
            });
        }
    }, []);

    const nocLongDescLink = (props.showOnlyImage)
        ? ''
        : (props.showLongDesc)
            ? nocDesc
            : <abbr className={classNameForNoc} title={nocDesc} aria-hidden="true">{noc}</abbr>

    const imgAlt = nocDesc;

    return (
        <div className={`wrsNoc ${clientClass}`} >
            {hasLink && url ? (
                <Link to={url} style={{ textDecoration: 'none' }}>
                    <div className='d-flex flex-row text-start align-center'>
                        {noc !== undefined && showImage ?
                            <div className="flag">
                                <LazyLoadImage
                                    alt={showImgAlt ? imgAlt : ''}
                                    src={pathFlag}
                                    height={process.env.REACT_APP_NOC_IMG_HEIGHT}
                                    width={process.env.REACT_APP_NOC_IMG_WIDTH}
                                />
                            </div>
                            : ""
                        }
                        {nocLongDescLink}
                    </div>
                </Link>)
                :
                <>
                    {noc !== undefined && showImage ?
                        <div className="flag">
                            <LazyLoadImage
                                alt={showImgAlt ? imgAlt : ''}
                                src={pathFlag}
                                height={process.env.REACT_APP_NOC_IMG_HEIGHT}
                                width={process.env.REACT_APP_NOC_IMG_WIDTH}
                            />
                        </div>
                        : ""
                    }
                    {nocLongDescLink}
                </>
            }
        </div>
    )
};

export const NocMemo = React.memo(Noc);

export default Noc



// CHECK IF IMAGE EXISTS
function checkImageExists(url, callback) {
    if (
        typeof window === 'undefined' ||
        typeof document === 'undefined'
    ) {

        callback(true)
        return
    }



    const img = new Image();
    img.src = url;

    if (img.complete) {
        callback(true);
    } else {
        img.onload = () => {
            callback(true);
        };

        img.onerror = () => {
            callback(false);
        };
    }
}


